var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "#F2F4F7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_18539_54785)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.8094 20.1495C27.8094 19.4939 27.7562 19.0156 27.6411 18.5195H20.1558V21.4782H24.5495C24.4609 22.2135 23.9826 23.3208 22.9195 24.0648L22.9046 24.1639L25.2714 25.9973L25.4353 26.0137C26.9412 24.6229 27.8094 22.5766 27.8094 20.1495Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1558 27.9465C22.3084 27.9465 24.1155 27.2378 25.4354 26.0154L22.9196 24.0665C22.2464 24.536 21.3428 24.8638 20.1558 24.8638C18.0476 24.8638 16.2582 23.473 15.6203 21.5508L15.5268 21.5587L13.0659 23.4633L13.0337 23.5527C14.3447 26.1571 17.0377 27.9465 20.1558 27.9465Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6206 21.5499C15.4523 21.0538 15.3549 20.5222 15.3549 19.9731C15.3549 19.4238 15.4523 18.8923 15.6117 18.3963L15.6073 18.2906L13.1155 16.3555L13.034 16.3942C12.4936 17.475 12.1836 18.6886 12.1836 19.9731C12.1836 21.2575 12.4936 22.4711 13.034 23.5518L15.6206 21.5499Z",
    fill: "#FBBC05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1558 15.0827C21.6529 15.0827 22.6627 15.7293 23.2385 16.2697L25.4885 14.0729C24.1067 12.7884 22.3084 12 20.1558 12C17.0377 12 14.3447 13.7894 13.0337 16.3937L15.6115 18.3957C16.2582 16.4735 18.0476 15.0827 20.1558 15.0827Z",
    fill: "#EB4335"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_18539_54785"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.6352,
    height: 16,
    fill: "white",
    transform: "translate(12.1826 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButton);
export default __webpack_public_path__ + "static/media/_Button.36c6d3861f2457ee6fe1ee3cb14f060d.svg";
export { ForwardRef as ReactComponent };